import { Injectable } from '@angular/core';

@Injectable()
export class ValidateService {

  constructor() { }

  validateSignup(user){
    if(user.first_name == undefined || user.last_name == undefined || user.email == undefined || user.contact_no == undefined || user.password == undefined){
      return false;
    }
    else{
      return true;
    }
  }

  validateLogin(user){
    if(user.email == undefined || user.password == undefined){
      return false;
    }
    else{
      return true;
    }
  }

  validateEmail(email){
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhoneNumber(contactNo) {
    var phoneno = /^\d{10}$/;
    return phoneno.test(contactNo)
  }

  validatePassword(password){
    var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
    return re.test(password);
  }

  validateINDCalculator(calculator){
    if(calculator.unitType == undefined){
      return {validation : false , message : "Please insert unit type"};
    }else if (calculator.unit == undefined){
      return {validation : false , message : "Please insert unit"};
    }else if (calculator.calValue == undefined){
      return {validation : false , message : "Please insert amount to calculate"};
    }else if (calculator.calValue == 0){
      return {validation : false , message : "Please insert amount more than zero"};
    }else if (calculator.voltageDrop == undefined){
      return {validation : false , message : "Please insert value to voltage drop"};
    }else if (calculator.cableLength == undefined){
      return {validation : false , message : "Please insert value to cable length"};
    }else if (calculator.wirecore == undefined){
      return {validation : false , message : "Please select a wire core"};
    }else if (calculator.wiretype == undefined){
      return {validation : false , message : "Please select a wire type"};
    }else if (calculator.wirematirial == undefined){
      return {validation : false , message : "Please select a material type"};
    }else if (calculator.installationMethod == undefined){
      return {validation : false , message : "Please select a installation method"};
    }else if (!/\d+(\.\d{1,5})?/.test(calculator.calValue)){
      return {validation : false , message : "Please insert only numbers to calculate"};
    }else if (!/\d+(\.\d{1,5})?/.test(calculator.cableLength)){
      return {validation : false , message : "Please insert only numbers to cable length"};
    }else{
      return  {validation : true , message : "Validated.!"};
    }

  }
  validateHCalculator(calculator){
    if(calculator.unitType == undefined){
      return {validation : false , message : "Please insert unit type"};
    }else if (calculator.calValue == 0){
      return {validation : false , message : "Please insert amount more than zero"};
    }else if (calculator.unit == undefined){
      return {validation : false , message : "Please insert unit"};
    }else if (calculator.calValue == undefined){
      return {validation : false , message : "Please insert amount to calculate"};
    }else if (calculator.cableLength == undefined){
      return {validation : false , message : "Please insert value to cable length"};
    }else if (!/\d+(\.\d{1,5})?/.test(calculator.calValue)){
      return {validation : false , message : "Please insert only numbers to calculate"};
    }else if (!/\d+(\.\d{1,5})?/.test(calculator.cableLength)){
      return {validation : false , message : "Please insert only numbers to cable length"};
    }else if ((calculator.calValue > 75) && (calculator.unit = "Amp")){
      return {validation : false , message : "Please insert 75 amp or lower value"};
    }else{
      return  {validation : true , message : "Validated.!"};
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/services/validate.service.ts